export function lexicalToPlainText(data: any): string {
  if (!data?.root?.children) return ''

  const extract = (node: any): string => {
    if (node.type === 'text') return node.text || ''
    if (node.children) return node.children.map(extract).join(' ')
    return ''
  }

  return data.root.children.map(extract).join(' ').replace(/\s+/g, ' ').trim()
}
